import { Injectable } from "@angular/core";
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    loadingRequestCount = 0;
    private loading = false;

    constructor(private spinnerService: NgxSpinnerService) { }

    show() {
        this.loadingRequestCount++;
        this.spinnerService;
        this.spinnerService.show(undefined,
            {
                type: 'line-scale',
                bdColor: 'rgba(0, 0, 0, 0.6)',
                color: '#fff',
                size: 'default'
            });
        this.loading = true;
    }

    hide() {
        this.loadingRequestCount--;
        if (this.loadingRequestCount <= 0) {
            this.loadingRequestCount = 0;
            this.spinnerService.hide();
        }
        this.loading = false;
    }

    isLoading(){
        return this.loading;
    }
}